import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'
import Vue from "vue";
import TextField from "./Input/TextField";
import PrimaryButton from "./Input/Button/PrimaryButton";
import SecondaryButton from "./Input/Button/SecondaryButton";
import ActionButton from "./Input/Button/ActionButton";
import IconButton from "./Input/Button/IconButton";
import ActionMenu from "./Input/ActionMenu";
import Dropdown from "./Input/Dropdown";
import DataTable from "./Input/DataTable";
import ActionButtonSecondary from "./Input/Button/ActionButtonSecondary";
import PasswordField from "./Input/PasswordField";
import HelpButton from "./Input/Button/HelpButton";
import DatePicker from "./Input/DatePicker";
import DangerButton from "./Input/Button/DangerButton"
import SwitchButton from "./Input/Button/SwitchButton"
import Checkbox from "./Input/Checkbox";
import BackButton from "./Input/Button/BackButton";
import NextButton from "./Input/Button/NextButton";
import TextAreaField from "@/components/Global/Input/TextAreaField";
import TretiaryButton from "@/components/Global/Input/Button/TretiaryButton";
import Icon from "@/components/Global/Misc/Icon";
import MiniSecondaryButton from "@/components/Global/Input/Button/MiniSecondaryButton.vue";

export const importComponents = () => {
    Vue.component('TextField', TextField)
    Vue.component('PrimaryButton', PrimaryButton)
    Vue.component('SecondaryButton', SecondaryButton)
    Vue.component('TretiaryButton', TretiaryButton)
    Vue.component('ActionButton', ActionButton)
    Vue.component('IconButton', IconButton)
    Vue.component('ActionMenu', ActionMenu)
    Vue.component('Dropdown', Dropdown)
    Vue.component('DataTable', DataTable)
    Vue.component('ActionButtonSecondary', ActionButtonSecondary)
    Vue.component('PasswordField', PasswordField)
    Vue.component('HelpButton', HelpButton)
    Vue.component('DatePicker', DatePicker)
    Vue.component('DangerButton', DangerButton)
    Vue.component('SwitchButton', SwitchButton)
    Vue.component('Checkbox', Checkbox)
    Vue.component('BackButton', BackButton)
    Vue.component('NextButton', NextButton)
    Vue.component('TextAreaField', TextAreaField)
    Vue.component('Icon', Icon)
    Vue.component('MiniSecondaryButton', MiniSecondaryButton)

    const latestNotificationTransition = createSimpleTransition('latest-notification-transition')
    Vue.component('latest-notification-transition', latestNotificationTransition)

    const bounceTransition = createSimpleTransition('bounce-transition')
    Vue.component('bounce-transition', bounceTransition)
}